module.exports = "/_next/static/images/7a55a9b8ae444ff520991061efe9e165-man-looking-up-smiling-lg@3x.jpg";